<template>
  <div class="header" flex="main:justify cross:center">
    <div flex>
      <div class="header__picker">
        <div class="header__date" flex="cross:center">
          <div
            v-for="(item,index) in tooggleDate"
            :key="index"
            class="header__date-row"
            flex="cross:center"
            :class="tooggleDateIndex === index?'header__date-row--active':''"
            @click="onHandleToggleDate(item,index)"
          >{{item}}</div>
        </div>
      </div>

      <div class="header__picker">
        <el-date-picker
          v-model="pickerValue"
          type="daterange"
          align="right"
          size="small"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd" format="yyyy-MM-dd">
        ></el-date-picker>
      </div>
      <div class="header__picker">
        <div class="header__date" flex="cross:center">
      <el-input
              v-model="userName"
              placeholder="商户名称"
      /></div></div>
      <div class="header__picker">
        <div class="header__date" flex="cross:center">
          <el-select
                  class="filter-item"
                  v-model="prov_cd"
                  placeholder="请选择省"
                  @change="currentSel(prov_cd)"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.areaid"
                    :label="item.areaname"
                    :value="item.areaid"
            ></el-option>
          </el-select>
        </div></div>
      <div class="header__picker">
        <div class="header__date" flex="cross:center">
          <el-select
                  class="filter-item"
                  v-model="city"
                  placeholder="请选择市"
                  @change="currentSel2(city)"
          >
            <el-option
                    v-for="item in typeOptions2"
                    :key="item.areaid"
                    :label="item.areaname"
                    :value="item.areaid"
            ></el-option>
          </el-select>
        </div></div>
      <div class="header__picker">
        <div class="header__date" flex="cross:center">
          <el-select
                  class="filter-item"
                  v-model="areaid"
                  placeholder="请选择区"
          >
            <el-option
                    v-for="item in typeOptions3"
                    :key="item.areaid"
                    :label="item.areaname"
                    :value="item.areaid"
            ></el-option>
          </el-select>
        </div></div>
    </div>

    <el-button type="primary" icon="el-icon-search" size="mini"  @click="handleSearchFormSubmit">搜索</el-button>
  </div>
</template>

<script>
  import * as agentService from "@/api/sys/agent";
export default {
  name: "Header",
  props: {
    title: {
      type: String,
      default: "hello world"
    },
    more: {
      type: Boolean,
      default: false
    },
    hasPicker: {
      type: Boolean,
      default: false
    },
    hasDate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const end = new Date();
    const start = new Date();
   // start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      console.info("#########");
    return {
      tooggleDateIndex: 0,
      tooggleDate: ["今日", "昨日", "近7天"],
        userName:'',
      prov_cd:'',
      city:'',
      areaid:'',
      typeOptions: [],
      typeOptions2: [],
      typeOptions3: [],
      pickerValue: [start, end],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  created() {},
  mounted() {
    var formData2 = new FormData() // 声明一个FormData对象
    agentService.getProvcd(formData2).then(data => {
      this.typeOptions=data;
    });
  },
  methods: {
      handleSearchFormSubmit() {
          this.$emit('refreshheader');
      },
    currentSel(val) {
      this.typeOptions2=[];
      this.city = "";
      this.areaid = "";
      var formData2 = new FormData() // 声明一个FormData对象
      formData2.append('type','city')
      formData2.append('areaid',val)
      agentService.getProvcd(formData2).then(data => {
        this.typeOptions2=data;
      });
    },
    currentSel2(val) {
      this.typeOptions3=[];
      this.areaid = "";
      var formData2 = new FormData() // 声明一个FormData对象
      formData2.append('type','area')
      formData2.append('areaid',val)
      agentService.getProvcd(formData2).then(data => {
        this.typeOptions3=data;
      });
    },
    onHandleToggleDate(item, index) {
      this.tooggleDateIndex = index;
      if(index==0){
          const end = new Date();
          const start = new Date();
          this.pickerValue=[start,end];
      }else if(index==1){
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          this.pickerValue=[start,end];
      }else if(index==2){
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          this.pickerValue=[start,end];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 12px;
  padding: 20px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  &__picker {
    box-sizing: border-box;
  }
  &__date {
    height: 30px;
    margin: 0 10px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
  }
  &__date-row {
    padding: 0 0.2rem;
    height: 30px;
  }
  &__date-row--active {
    background-color: #409eff !important;
    color: #fff;
  }
  &__date-row:not(:last-child) {
    border-right: 1px solid #dcdfe6;
  }


}


</style>
